import { createAction } from '@reduxjs/toolkit';

export const showSidebar = createAction('sidebar/show');
export const hideSidebar = createAction('sidebar/hide');
export const toggleSidebar = createAction<boolean, 'sidebar/toggle'>('sidebar/toggle');
